import { resolveImagePath } from '@/utils/imageResolver';

export function Header() {
  const navigationItems = [
    { text: 'HOME', href: '/', active: true },
    { text: 'WHERE TO BUY', href: '/buy' },
    { text: 'SUPPORT', href: '/support' },
    { text: 'FAQS', href: '/faqs' },
    { text: 'DOWNLOADS', href: '/downloads' },
    { text: 'HISTORY', href: '/history' },
    { text: 'LINKS', href: '/links' },
    { text: 'CONTACT US', href: '/contact' }
  ];

  return (
    <header className="w-full">
      {/* Main Header Section with Logo and Instruments */}
      <div className="w-full bg-white border-b border-rcallen-brown-border">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          {/* RC Allen Logo and Instruments Display */}
          <div className="flex-1">
            <img 
              src={resolveImagePath('/images/RC_Allen_Banner.png')} 
              alt="RC Allen Instruments"
              className="h-24 w-auto"
            />
          </div>
          
          {/* Social Media and KMC Branding */}
          <div className="flex flex-col items-end space-y-2">
            <div className="flex items-center space-x-2 text-sm">
              <span className="text-rcallen-primary-blue font-verdana">Find us on</span>
              <a 
                href="https://www.facebook.com/flyrcallen/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-rcallen-secondary-blue hover:text-rcallen-primary-blue"
              >
                Facebook
              </a>
            </div>
            <div className="text-xs text-rcallen-primary-blue font-verdana">
              <div className="text-center">MANUFACTURED BY</div>
              <div className="font-bold text-center">KMC</div>
              <div className="text-center">KELLY MANUFACTURING COMPANY</div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="w-full bg-rcallen-brown-border">
        <div className="max-w-6xl mx-auto">
          <ul className="flex items-center justify-center space-x-0">
            {navigationItems.map((item, index) => (
              <li key={index} className="relative">
                <a
                  href={item.href}
                  className={`
                    px-4 py-3 block text-sm font-bold font-arial uppercase
                    ${item.active 
                      ? 'bg-rcallen-brown-border text-rcallen-yellow' 
                      : 'bg-rcallen-brown-border text-white hover:text-rcallen-yellow'
                    }
                    transition-colors duration-200
                  `}
                >
                  {item.text}
                </a>
                {index < navigationItems.length - 1 && (
                  <span className="absolute right-0 top-0 h-full w-px bg-white opacity-30" />
                )}
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </header>
  );
}